module.exports = __webpack_public_path__ + "static/media/simple_br.3106adb8.svg";